export const vehicleAppraiserInitialProps = async ({context: {domain, i18n}}) => {
  const config = domain.get('config')
  const {VEHICLE_APPRAISER_PAGE_NAME: pageName} = config.get('page')

  const initialData = {helmet: {}, pageName}

  const getSeoDataPromise = domain.get('get_seo_data_use_case').execute({
    culture: i18n.culture,
    pageName
  })

  const getBreadcrumbPromise = domain.get('get_breadcrumbs_breadcrumb_use_case').execute({pageName})

  const getSellVehicleConfigFormPromise = domain
    .get('get_sell_vehicle_config_form_use_case')
    .execute({withPostalCodeField: true})

  const [
    {
      value: [seoDataError, seoDataResponse]
    },
    {value: [, getBreadcrumbResponse] = []},
    {
      value: [, sellVehicleConfigForm]
    }
  ] = await Promise.allSettled([getSeoDataPromise, getBreadcrumbPromise, getSellVehicleConfigFormPromise])

  initialData.breadcrumb = getBreadcrumbResponse
  initialData.sellVehicleConfigForm = sellVehicleConfigForm

  if (!seoDataError) initialData.helmet = seoDataResponse.head || {}

  return initialData
}
